import { REMEMBER_ME } from '../constants/cookie';
import {
  ACCESS_TOKEN,
  ACTIVITY_REF,
  ID_TOKEN,
  SECURED_ID_TOKEN
} from '../constants/unbind-app-instance';

export const getB2CIAMTokenArray = idTokens => {
  const revokeArray = [REMEMBER_ME, ACCESS_TOKEN, ACTIVITY_REF, SECURED_ID_TOKEN];

  if (idTokens?.size) {
    revokeArray.push(ID_TOKEN);
  }

  return revokeArray;
};
